/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Api from "@/helpers/api.js";

export default {
	// Get Roles
	getRoles({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/role")
				.then((result) => {
					commit("ADD_ITEM", Object.assign(result.data));
					resolve(result);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	// Crea un rol
	addRole({commit}, object) {
		return new Promise((resolve, reject) => {
			Api.post("/role", object)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},

	async deleteRol({commit, dispatch}, payload) {
		try {
			await Api.delete("/role/" + payload);
			dispatch("getRoles");
			// statements
		} catch (e) {
			return e;
		}
	},
	// Actualiza el Rol
	updateRole({commit}, role) {
		let id = role.id;
		delete role["id"];
		return new Promise((resolve, reject) => {
			Api.put(`/role/${id}`, JSON.stringify(role))
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},

	// Permission
	getPermissions({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/permission")
				.then((result) => {
					commit("SET_PERMISSIONS", result.data);
					resolve(result);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	// Role permission
	getRolPermission({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/rolepermission")
				.then((result) => {
					commit("SET_ROLE_PERMISSIONS", result.data);
					resolve(result);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
